import { Reveal, SectionHeading } from "./Reveal";
import { BadgeCheck, Users, Dog, Cigarette, WashingMachine, Armchair, Ship, Truck } from "lucide-react";

const icons = {
  clc: BadgeCheck,
  group: Users,
  pet: Dog,
  smoking: Cigarette,
  laundry: WashingMachine,
  patio: Armchair,
  boat: Ship,
  truck: Truck,
};

export const AmenitiesSection = ({ features = [] }) => {
  if (!features.length) return null;
  return (
    <section id="amenities" className="bg-[#F8F6F0] py-20 md:py-28" data-testid="amenities-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <SectionHeading eyebrow="Good to Know" title="Traveler-Friendly, Through and Through" testId="amenities" />
          <Reveal delay={0.1}>
            <p className="text-[#4A5568] mt-5 max-w-2xl text-sm sm:text-base leading-relaxed">
              We accept <span className="font-semibold text-[#0A192F]">CLC Lodging</span>, offer <span className="font-semibold text-[#0A192F]">group rates</span>, and keep things easy for every kind of traveler — pets, smokers, boaters and big rigs included.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {features.map((f, i) => {
            const Icon = icons[f.key] || BadgeCheck;
            return (
              <Reveal key={f.key || f.title} delay={(i % 4) * 0.06}>
                <div
                  className="group bg-[#FAF8F5] border border-[#0D1B2A]/10 rounded-2xl p-5 sm:p-6 h-full hover:border-[#C5A059]/50 hover:shadow-lg transition-all duration-300"
                  data-testid={`amenity-card-${f.key || i}`}
                >
                  <div className="w-11 h-11 rounded-full bg-[#0A192F] text-[#C5A059] flex items-center justify-center group-hover:bg-[#C5A059] group-hover:text-[#0A192F] transition-colors duration-300">
                    <Icon size={19} />
                  </div>
                  <h3 className="font-serif-display text-lg sm:text-xl font-semibold text-[#0A192F] mt-4">{f.title}</h3>
                  <p className="text-[#4A5568] text-xs sm:text-sm mt-1.5 leading-relaxed">{f.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
